import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import RtLink from '@/lib/rt/RtLink'
import RtFile from '@/lib/rt/RtFile'
import RtIframe from '@/lib/rt/RtIframe'
import RtImage from '@/lib/rt/RtImage'
import RtImageList from '@/lib/rt/RtImageList'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import clsx from 'clsx'

const components = {
	block: {
		disclaimer: ({ children }) => <p className="text-xs">{children}</p>,
		h2: ({ children }) => <h2 className="h2">{children}</h2>,
		h3: ({ children }) => <h3 className="h3">{children}</h3>,
		h4: ({ children }) => <h4 className="h4">{children}</h4>,
	},
	marks: {
		link: RtLink,
		pill: ({ children }) => <span className="pill">{children}</span>,
	},
	types: {
		rtFile: RtFile,
		rtIframe: RtIframe,
		rtImage: RtImage,
		rtImageList: RtImageList,
		cta: ({ value }) => <p><CTA {...value} /></p>,
	},
}

const HeroMain = ({ heading, _rawRichtext, cta, image, pattern }) => (
	<section className={clsx('relative z-[2] border-r-[24px] md:border-r-[64px] border-orange', pattern)}>
		<div className="grid md:grid-cols-[minmax(50%,1fr),minmax(50%,650px)] items-center overflow-hidden">
			<div className="max-w-[650px] mx-auto p-8 richtext">
				<HTag data-aos="fade-right" className="h1 md:text-6xl" {...heading} />
				<Richtext raw={_rawRichtext} components={components} />
				<p><CTA {...cta} /></p>
			</div>

			<figure data-aos="fade-right" className="ml-auto">
				<Img image={image} />
			</figure>
		</div>
	</section>
)

export default HeroMain
